import { ReactNode } from 'react';
import Header from './Header';
import BottomNav from './BottomNav';

interface AppShellProps {
  children: ReactNode;
}

const AppShell = ({ children }: AppShellProps) => {
  return (
    <div className="flex flex-col h-screen bg-[var(--color-bg)]">
      <Header />
      <main className="flex-1 overflow-hidden pt-16 pb-20">
        <div className="h-full max-w-4xl mx-auto px-4">
          {children}
        </div>
      </main>
      <BottomNav />
    </div>
  );
};

export default AppShell;
